<script setup lang="ts">
const props = defineProps<{
  text: string
  disabled?: boolean
  type: 'main' | 'sub'
  onClick?: () => void
}>()
</script>

<template>
  <button
    class="base-small-button body-md"
    :class="props.type"
    :disabled="props.disabled"
    @click="props.onClick"
  >
    {{ props.text }}
  </button>
</template>

<style scoped>
.base-small-button {
  width: 144px;
  height: 56px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  letter-spacing: 0;
  text-align: center;
}

.base-small-button:not(:disabled):hover {
  text-decoration: underline;
  cursor: pointer;
}

.base-small-button.main {
  background-color: var(--tint-500);
  color: var(--white);
}

.base-small-button.sub {
  background-color: var(--tint-100);
  color: var(--tint-500);
}

.base-small-button:disabled.main {
  background-color: var(--gray-800);
  color: var(--gray-600);
}

.base-small-button:disabled.sub {
  background-color: var(--tint-100);
  color: var(--tint-300);
}
</style>
